import * as React from "react";

const UploadSpecIcon = ({ width = 16, height = 16, strokeWidth = 2.5, ...props }) => (
  <svg
    width={width}
    height={height}
    viewBox="14 8 18 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M23 10V19.3333M19.1111 13.8889L23 10L26.8889 13.8889M30 19.3333V22.4444C30 22.857 29.8361 23.2527 29.5444 23.5444C29.2527 23.8361 28.857 24 28.4444 24H17.5556C17.143 24 16.7473 23.8361 16.4556 23.5444C16.1639 23.2527 16 22.857 16 22.4444V19.3333"
      stroke="white"
      strokeWidth={strokeWidth}
      strokeLinecap="round"
    />
  </svg>
);
export default UploadSpecIcon;
